import * as Unicons from '@iconscout/react-unicons';
import Pagination from '@material-ui/lab/Pagination';
import { Alert, Button, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { PresentImage } from '../../../components/ApresentarImagem';
import { CursoCard } from '../../../components/Curso/curso-card.component';
import SidebarAndContainer from '../../../components/sidebar-and-container/sidebar-and-container.component';
import Title from '../../../components/title/title.component';
import useCertificate from './hooks/use-certificate';
import { useVerifyUserAvaliacao } from './hooks/use-verify-user-avaliacao.hook';
import './trilha-id.styles.scss';
import useTrilhaId from './use-trilha-id.hook';

export const CursosTrilha = () => {
  const navigate = useNavigate();
  const {
    trilha,
    nome,
    onPageChange,
    setSearch,
    cursoData,
    icon,
    hasAvaliacao,
    cursoListData,
  } = useTrilhaId();

  useVerifyUserAvaliacao();
  const { hasCertificado, dowloadCertificate } = useCertificate(cursoListData);
  const { t } = useTranslation(['instrutor', 'trilhas', 'common']);

  return (
    <SidebarAndContainer cursos={true}>
      <div className="trilha-id-container__top-content">
        <div className="top-content__back-button-icon-title">
          <Link to="/cursos" className="button-second">
            <Unicons.UilArrowLeft />
            {t('common:back')}
          </Link>

          <div className="back-button-icon-title__icon-title">
            {icon && <PresentImage size={40} link={icon} />}
            <Title title={nome} />
          </div>
        </div>
      </div>

      <Form.Item className="trilha-id-container__searchbar-input">
        <i className="searchbar-input__search-icon">
          <Unicons.UilSearch size="24" color="var(--dark-secondary)" />
        </i>
        <input
          onChange={(e) => setSearch(e.target.value)}
          placeholder={t("trilhas:findTrilhaByCourse")}
          className="searchbar-input__input-search"
        />
      </Form.Item>
        <Alert
          style={{padding: '15px'}}
          message={t('trilhas:resultsFound', { count: cursoData?.totalElements || 0 })}
          closeIcon
          type='info'
          showIcon
        />
      <div className="trilha-id-container__avaliacao_container">
        {trilha?.avaliacao && hasAvaliacao && (
          <div className="trilha-id-container__avaliacao">
            <Button
              onClick={() => navigate(`/trilha/${trilha.id}/avaliacao`)}
              disabled={!hasAvaliacao}
              className="button-primary"
            >
              {t("trilhas:startEvaluation")}
            </Button>
          </div>
        )}
        {trilha?.certificado && hasCertificado && (
          <div className="trilha-id-container__certificado">
            <Button
              onClick={() => dowloadCertificate()}
              disabled={!hasCertificado}
              className="button-primary"
            >
              {t('trilhas:issueCertificate')}  <Unicons.UilTrophy size={18} style={{ marginLeft: 3 }} />
            </Button>
          </div>
        )}
      </div>

      <div className="trilha-id-container__trilha-cards">
        {cursoData?.content?.map?.((curso) => (
          <CursoCard t={t} key={curso.id} trilha={trilha} curso={curso} />
        ))}
      </div>

      <div className="d-flex-row j-center-a-center w-100 pb-50">
        <Pagination
          onChange={(event, page) => onPageChange(event, page - 1)}
          page={cursoData ? cursoData.pageable.pageNumber + 1 : 0}
          count={cursoData ? cursoData.totalPages : 0}
        />
      </div>
    </SidebarAndContainer>
  );
};
